import { call, put, takeEvery } from 'redux-saga/effects';
import { targetedCatalogActionCreators, TargetedCatalogActionKeys, UpdateTargetedItemGroupOrder } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateTargetedItemGroup } from '../targetedCatalogApi';
import { ITargetedCatalogGroup } from '../targetedCatalogInterfaces';

function* updateTargetedItemGroupOrderSaga(action: UpdateTargetedItemGroupOrder) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<ITargetedCatalogGroup[]> = yield call(
    updateTargetedItemGroup,
    action.payload,
    true
  );

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(targetedCatalogActionCreators.setItemGroups(response.value));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateTargetedItemGroupOrder() {
  yield takeEvery(TargetedCatalogActionKeys.UPDATE_TARGETED_ITEM_GROUP_ORDER, updateTargetedItemGroupOrderSaga);
}
